<template>
  <div class="search-products-container">
    <div class="search-input-section">
      <mf-tooltip top :disabled="!disabled">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <mf-search v-model="searchValue" autofocusclass="mx-3" dense :loading="loading" :disabled="disabled" @input="querySelections" />
          </div>
        </template>
        <span>{{ disabledSearchTooltip }}</span>
      </mf-tooltip>
    </div>
    <div class="results-section">
      <span class="results-title">Resultados ({{ products.length + productsGroups.length }})</span>
      <div class="items-content">
        <v-list class="pt-0">
          <v-list-item v-for="(group, index) in productsGroups" :key="`${group.name}-${index}`" class="searched-list" @click="setGroup(group)">
            <v-list-item-content>
              <div>
                <mf-icon fill color="marca-1"> folder </mf-icon>
                <span class="body-1 ml-4">{{ group.name }}</span>
              </div>
            </v-list-item-content>
            <v-list-item-action>
              <mf-icon>chevron_right</mf-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-for="(item, searchedIndex) in products" :key="searchedIndex" class="searched-list" @click="setItem(item)">
            <v-list-item-content>
              <span class="body-1">{{ item.sku }} - {{ item.name }}</span>
            </v-list-item-content>
            <v-list-item-action>
              <mf-icon>chevron_right</mf-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>
    </div>
  </div>
</template>

<script>
import { mariaCampaign } from '../../../mixins/maria-campaign'

export default {
  name: 'SearchProducts',
  mixins: [mariaCampaign],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onlyActive: {
      type: Boolean,
      default: false,
    },
    productsGroups: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    querySelections: {
      type: Function,
    },
    setItem: {
      type: Function,
    },
    setGroup: {
      type: Function,
    },
  },
  data: () => ({}),
  computed: {
    disabledSearchTooltip() {
      return `Não é possível adicionar mais produtos em uma campanha ${this.campaign.status === 'FINISHED' ? 'concluída' : 'ativa'}.`
    },
    searchValue: {
      get() {
        return this.searchProductsValue
      },
      set(value) {
        this.setProductsSearchValue(value)
      },
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.search-products-container {
  display: flex;
  flex-direction: column;
  padding: 24px 24px 0 0;
  max-height: 600px;
  min-height: 400px;
  overflow: auto;

  .results-section {
    .items-content {
      border-radius: 10px;
      overflow-y: auto;
      margin-top: 20px;
    }
  }

  .search-section {
    margin: 0px 0px;
    margin-top: -20px;
  }

  .searched-list:not(:first-of-type) {
    border-top: 1px solid $cinza-l70;
  }
  .searched-list {
    background-color: #f3f3f3 !important;
  }
}
</style>
